// Ottimizza al RENDER gli URL immagine Unsplash/Pexels forzando una larghezza di
// rendering ridotta. Funziona anche quando l'URL ha GIA' dei parametri (li
// sovrascrive ripartendo dall'URL base), così gestisce le immagini salvate a
// piena risoluzione. Vale sia in UAT sia in produzione (fix lato codice).
export const optimizeImageUrl = (url, width = 800, quality = 72) => {
  if (!url || typeof url !== 'string') return url;
  const base = url.split('?')[0];
  if (url.includes('unsplash.com')) {
    return `${base}?w=${width}&q=${quality}&auto=format&fit=crop`;
  }
  if (url.includes('images.pexels.com')) {
    return `${base}?auto=compress&cs=tinysrgb&w=${width}`;
  }
  return url;
};
